import cx from 'classnames'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import {
  Insights as InsightsIcon,
  Logs as LogsIcon,
  SettingsCog as SettingsCogIcon,
} from 'common/icons'
import {
  getContentHasVariants,
  getElementHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'

import { ActivePanel, HandleActivePanelChange } from './RightSection'

type Props = {
  activePanel: ActivePanel | undefined
  handleActivePanelChange: HandleActivePanelChange
}

const CollapsedIcons = ({ activePanel, handleActivePanelChange }: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()
  const isOptimized = getIsOptimized(selectedElement)

  const commonClassName = 'cursor-pointer hover:text-gold-700'
  const hasVariants = getContentHasVariants(content)
  const hasElementVariants = getElementHasVariants(selectedElement)

  return (
    <>
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="campaignLogs-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Logs"
          placement="top"
          prefixIcon={
            <LogsIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'campaignLogs',
                'text-gold-600 ': activePanel !== 'campaignLogs',
              })}
            />
          }
          onClick={() => handleActivePanelChange('campaignLogs')}
        />
      )}
      {isOptimized && (
        <ButtonWithTooltip
          data-testid="advanced-settings-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Advanced settings"
          placement="top"
          prefixIcon={
            <SettingsCogIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'advancedSettings',
                'text-gold-600 ': activePanel !== 'advancedSettings',
              })}
            />
          }
          onClick={() => handleActivePanelChange('advancedSettings')}
        />
      )}
      {selectedElement && hasVariants && (
        <div className="flex items-stretch">
          <ExportMenuButton tooltipPlacement="top" />
        </div>
      )}
      {isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="insights-sidebar-button"
          variant="icon"
          tooltip
          tooltipText="Insights"
          placement="top"
          prefixIcon={
            <InsightsIcon
              size={6}
              isDefaultColor={false}
              className={cx(commonClassName, {
                'text-base-700': activePanel === 'insights',
                'text-gold-600 ': activePanel !== 'insights',
              })}
            />
          }
          onClick={() => handleActivePanelChange('insights')}
        />
      )}
    </>
  )
}

export default CollapsedIcons
